import Base from './components/cells/Base';
import Toggle from './components/cells/Toggle';

export default function ToggleCell() {}

ToggleCell.prototype.init = function (params) {
    this.eGui = Base(Toggle(params), params);
    return;
};

ToggleCell.prototype.getGui = function () {
    return this.eGui;
};
